import PropTypes from "prop-types";
import classNames from "classnames";

const FilterIcon = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const filterIconClassName = classNames("filter-icon", className);

	return (
		<svg
			width={size}
			className={filterIconClassName}
			{...props}
			height={size}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				fill={fill}
				d="M9 10.833C9.46027 10.833 9.83301 11.2067 9.83301 11.667V13.667C9.83283 14.1271 9.46016 14.5 9 14.5H7.66699C7.20683 14.5 6.83318 14.1271 6.83301 13.667V13.333H2.33301C1.96507 13.3328 1.66717 13.0349 1.66699 12.667C1.66699 12.2989 1.96496 12.0002 2.33301 12H6.83301V11.667C6.83301 11.2067 7.20673 10.833 7.66699 10.833H9ZM13.667 12C14.035 12.0002 14.333 12.2989 14.333 12.667C14.3328 13.0349 14.0349 13.3328 13.667 13.333H11C10.6319 13.333 10.3332 13.035 10.333 12.667C10.333 12.2988 10.6318 12 11 12H13.667ZM7 6.16699C7.46027 6.16699 7.83301 6.53976 7.83301 7V7.33301H13.667C14.035 7.33318 14.333 7.63191 14.333 8C14.333 8.36809 14.035 8.66682 13.667 8.66699H7.83301V9C7.83301 9.46027 7.46027 9.83301 7 9.83301H5.66699C5.20675 9.83301 4.83301 9.46027 4.83301 9V7C4.83301 6.53976 5.20675 6.16699 5.66699 6.16699H7ZM3.66699 7.33301C4.03503 7.33318 4.33301 7.63191 4.33301 8C4.33301 8.36809 4.03503 8.66682 3.66699 8.66699H2.33301C1.96497 8.66682 1.66699 8.36809 1.66699 8C1.66699 7.63191 1.96497 7.33318 2.33301 7.33301H3.66699ZM10.333 1.5C10.7932 1.5 11.1668 1.87292 11.167 2.33301V4.33301C11.167 4.79325 10.7933 5.16699 10.333 5.16699H9C8.53973 5.16699 8.16699 4.79325 8.16699 4.33301V4H2.33301C1.96496 3.99982 1.66699 3.70109 1.66699 3.33301C1.66717 2.96508 1.96507 2.66717 2.33301 2.66699H8.16699V2.33301C8.16717 1.87292 8.53984 1.5 9 1.5H10.333ZM13.667 2.66699C14.0349 2.66717 14.3328 2.96508 14.333 3.33301C14.333 3.70109 14.035 3.99982 13.667 4H12.333C11.965 3.99982 11.667 3.70109 11.667 3.33301C11.6672 2.96508 11.9651 2.66717 12.333 2.66699H13.667Z"
			/>
		</svg>
	);
};

FilterIcon.propTypes = {
	className: PropTypes.string,
	fill: PropTypes.string,
	size: PropTypes.number,
};

export default FilterIcon;
